import { ConfigMerchantModel } from '@src/models';

export const filterOutDraftsFromMerchant = (
  merchant: ConfigMerchantModel
): ConfigMerchantModel => ({
  id: merchant.id,
  name: merchant.name,
  sites: merchant.sites.filter(site => !site.metadata?.draft?.isDraft),
});
